module.exports = __webpack_public_path__ + "img/data-handling-screen-2.c551d76.jpg";